/**
 * Image Utilities for Musa Group Frontend
 */

export function getStorageBaseUrl() {
  let apiUrl = process.env.REACT_APP_API_URL || "";
  
  if (!apiUrl && typeof window !== "undefined" && window.location?.origin) {
    return window.location.origin;
  }

  if (apiUrl.startsWith("/")) {
    const origin = typeof window !== "undefined" && window.location?.origin ? window.location.origin : "";
    apiUrl = `${origin}${apiUrl}`;
  }

  return apiUrl
    .replace(/\/api(\/v1)?\/?$/, "")
    .replace(/\/laravel-api\/?$/, "")
    .replace(/\/$/, "");
}

/**
 * Resolves any raw image URL/path (relative or absolute) to a full, valid image URL.
 * Handles storage paths like 'storage/services/1.jpg', '/storage/avatars/u.png', etc.
 */
export function toAbsoluteUrl(rawUrl) {
  const u = String(rawUrl || "").trim();
  if (!u) return "";

  if (/^(blob:|data:)/i.test(u)) {
    return u;
  }

  const storageBase = getStorageBaseUrl();

  // If it's any storage path (relative or absolute from an old domain/port), re-base it onto storageBase
  if (u.includes("/storage/")) {
    const storagePath = u.substring(u.indexOf("/storage/"));
    let clean = storagePath.replace(/^\/+/, "");
    if (clean.startsWith("storage/")) {
      clean = clean.replace(/^storage\//, "");
    }
    const fullPath = `${storageBase}/storage/${clean}`;
    if (fullPath.startsWith("/") && typeof window !== "undefined" && window.location?.origin) {
      return `${window.location.origin}${fullPath}`;
    }
    return fullPath;
  }

  if (/^https?:\/\//i.test(u)) {
    return u;
  }

  let clean = u.replace(/^\/+/, "");

  if (clean.startsWith("laravel-api/")) {
    clean = clean.replace(/^laravel-api\//, "");
  }

  if (clean.startsWith("storage/")) {
    clean = clean.replace(/^storage\//, "");
  }

  // Bare image filename (e.g. uuid.png) without folder prefix belongs in avatars/
  if (!clean.includes("/") && /\.(png|jpe?g|gif|webp|svg)$/i.test(clean)) {
    clean = `avatars/${clean}`;
  }

  const fullPath = `${storageBase}/storage/${clean}`;

  if (fullPath.startsWith("/") && typeof window !== "undefined" && window.location?.origin) {
    return `${window.location.origin}${fullPath}`;
  }

  return fullPath;
}

/**
 * Safe image onError handler to apply fallback source once without infinite loops.
 */
export function handleImageFallback(event, fallbackSrc) {
  if (!event || !event.currentTarget) return;
  if (event.currentTarget.dataset.fallbackApplied === "true") return;
  event.currentTarget.dataset.fallbackApplied = "true";
  if (fallbackSrc) {
    event.currentTarget.src = fallbackSrc;
  }
}
